import {
  CardFilter,
  SortInput,
} from 'apps/shared/scripts/__generated__/graphql.generated';

import { filterOptions, sortOptions } from './constants';

export const getSortLabel = ({
  sortBy,
  sortOrder,
}: SortInput): string | undefined => {
  const option = sortOptions.find(
    (option) => option.sortBy === sortBy && option.sortOrder === sortOrder,
  );
  return option ? option.label : 'Sort By';
};

export const getFilterLabel = (filter: CardFilter): string | undefined => {
  const option = filterOptions.find(
    (option) => option.status === filter.status,
  );
  return option ? option.label : 'Filter By';
};
